import React from 'react';
import Main from './container/Main/Main';

function App() {
  return (
    <div>
      <Main />
    </div>
  );
}

export default App;
